var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.3804H1C0.447715 11.3804 0 11.8281 0 12.3804C0 12.9327 0.447715 13.3804 1 13.3804H23C23.5523 13.3804 24 12.9327 24 12.3804C24 11.8281 23.5523 11.3804 23 11.3804Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 4.38037H1C0.447715 4.38037 0 4.82809 0 5.38037C0 5.93266 0.447715 6.38037 1 6.38037H23C23.5523 6.38037 24 5.93266 24 5.38037C24 4.82809 23.5523 4.38037 23 4.38037Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18.3804H1C0.447715 18.3804 0 18.8281 0 19.3804C0 19.9327 0.447715 20.3804 1 20.3804H23C23.5523 20.3804 24 19.9327 24 19.3804C24 18.8281 23.5523 18.3804 23 18.3804Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurger);
export default __webpack_public_path__ + "static/media/menu-burger.0ac30e1c9b9a5000bea25968d2e47a5e.svg";
export { ForwardRef as ReactComponent };